export interface ContainerTypeFreightType {
  id: number;
  name: string;
}

/**
 * A QuantityType with isContainer = true (seed: "20 STD", "40 HC"). `quantityInM3` is the PHYSICAL
 * volume of the container; how many m3 of a species fit in it lives in the species capacity grid.
 */
export class ContainerType {
  /** Freight types linked to this container type (QuantityType.FreightTypes), for display. */
  public freightTypes: ContainerTypeFreightType[] = [];

  constructor(
    public id?: number,
    public name: string = '',
    public quantityInM3: number | null = null,
    public maxPayloadTons: number | null = null,
    public isActive: boolean = true,
    public freightTypeId: number | null = null,
  ) {}
}
